import React from "react";
import { TipFilter } from "model/Tip";
import { Checkbox } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { Text } from "components/Typography/text.styled";
import { FilterLabel, SpaceBtwItemsCenter } from "../tips.styled";
import { CheckBoxContainer, FilterContainer } from "web-apps/company/components/gig/gigList/gigs.styled";

type TipFiltersProps = {
  selectedFilter: TipFilter;
  setSelectedFilter: (filter: TipFilter) => void;
};

export const TipFilters: React.FC<TipFiltersProps> = (props) => {
  const { t } = useTranslation();

  return (
    <FilterContainer style={{ margin: 10 }}>
      <SpaceBtwItemsCenter>
        {Object.values(TipFilter).map((filter) => (
          <CheckBoxContainer key={filter}>
            <FilterLabel onClick={() => props.setSelectedFilter(filter)}>
              <Checkbox
                checked={props.selectedFilter === filter}
                value={filter}
                onClick={(e) => {
                  e.stopPropagation();
                  props.setSelectedFilter(filter);
                }}
              />
              <Text
                style={{
                  minWidth:
                    filter === TipFilter.ReadyToPayout ? "130px" : "auto",
                }}
              >
                {t(`CompanyTip.${filter}`)}
              </Text>
            </FilterLabel>
          </CheckBoxContainer>
        ))}
      </SpaceBtwItemsCenter>
    </FilterContainer>
  );
};
